import { NoData } from "pro-features/components/NoData/src/NoData";
import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";

const EmptyDomainsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

const Icon = styled(SWReactIcons)`
    height: 90px;
    width: 160px;
`;

export const EmptyDomains = () => {
    return (
        <EmptyDomainsContainer>
            <NoData
                title={""}
                subtitle={""}
                SvgImage={() => <Icon iconName={"company-empty-suggestions"} />}
            />
        </EmptyDomainsContainer>
    );
};
